import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

import { Firebase } from '../firebase';
import { Item } from '../pages';

type AdminReservableItemProps = {
  item: Item;
};

export const AdminReservableItem: React.FC<AdminReservableItemProps> = ({
  item,
}) => {
  const [returnLoading, setReturnLoading] = React.useState(false);
  const [changeLoading, setChangeLoading] = React.useState(false);

  const onPressToggle = async () => {
    if (
      window.confirm(
        `${item.data.display_name}을 ${
          item.data.status === 'unavailable' ? '활성화' : '비활성화'
        } 하시겠습니까?`,
      )
    ) {
      setChangeLoading(true);
      await Firebase.updateItem(item.id, {
        status:
          item.data.status === 'unavailable' ? 'not_reserved' : 'unavailable',
      });
      setChangeLoading(true);
      window.alert('처리완료 되었습니다.');
      window.location.reload();
    }
  };

  const onPressReturn = async () => {
    if (
      window.confirm(`${item.data.display_name}을 강제반납 처리하시겠습니까?`)
    ) {
      setReturnLoading(true);
      await Firebase.updateItem(item.id, {
        status: 'not_reserved',
        returned_at: moment().format('YYYY년 MM월 DD일 HH:mm:ss'),
      });
      setReturnLoading(false);
      window.alert('처리완료 되었습니다.');
      window.location.reload();
    }
  };

  const reserved = item.data.status !== 'not_reserved';

  return (
    <Container>
      <Header>
        <Name unavailable={item.data.status === 'unavailable'}>
          {item.data.display_name}
        </Name>
        {item.data.status !== 'unavailable' && (
          <Status reserved={reserved}>
            {reserved ? '대여중' : '대여가능'}
          </Status>
        )}
      </Header>

      {item.data.reserved_by && (
        <>
          <Info style={{ fontWeight: 'bold', marginTop: 20 }}>최근 대여자</Info>
          <Info>{item.data.reserved_by}</Info>
        </>
      )}

      {item.data.reserved_at && (
        <>
          <Info style={{ fontWeight: 'bold', marginTop: 20 }}>
            최근 대여일시
          </Info>
          <Info>{item.data.reserved_at}</Info>
        </>
      )}

      {item.data.status !== 'reserved' && item.data.returned_at && (
        <>
          <Info style={{ fontWeight: 'bold', marginTop: 20 }}>
            최근 반납일시
          </Info>
          <Info>{item.data.returned_at}</Info>
        </>
      )}

      <Actions>
        {item.data.status === 'reserved' && (
          <Button
            unavailable={false}
            onClick={onPressReturn}
            disabled={returnLoading}
          >
            강제반납
          </Button>
        )}
        <Button
          unavailable={item.data.status === 'unavailable'}
          onClick={onPressToggle}
          disabled={changeLoading}
        >
          {item.data.status === 'unavailable' ? '활성화' : '비활성화'}
        </Button>
      </Actions>
    </Container>
  );
};

const Container = styled.div`
  padding: 10px 0;
  border-bottom: 1px solid #e9e9e9;

  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 1500px) {
    border: 1px solid #e9e9e9;
    border-radius: 5px;
    padding: 10px;
    height: fit-content;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
`;

const Name = styled.h3<{ unavailable: boolean }>`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => (props.unavailable ? '#a9a9a9' : 'black')};
`;

const Status = styled.div<{ reserved?: boolean }>`
  padding: 4px 8px;
  color: ${(props) => (props.reserved ? '#a9a9a9' : '#023978')};

  margin-left: 10px;
  font-size: 10px;
  border-radius: 5px;
`;

const Info = styled.p`
  margin-top: 10px;
`;

const Actions = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  margin-top: 20px;
`;

const Button = styled.button<{ unavailable: boolean }>`
  padding: 9px;
  background-color: ${(props) => (props.unavailable ? 'white' : '#023978')};
  border: 1px solid #023978;
  color: ${(props) => (props.unavailable ? '#023978' : 'white')};
  font-size: 14px;
  border-radius: 5px;
  margin-right: 10px;
`;
